// Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved.
import {IManageUser, UserRole} from '../types/user';
import { OrgType } from '../types/group';

export function isD3EFreeUser(user: IManageUser): boolean {
    let noPermissions = true;
    try {
        if (user) {
            if (user.dashboard_page || user.organizations || user.administrator ||
                user.endpoints_page || user.threat_history || user.event_viewer ||
                user.invoices_page || user.administrator_ro || user.role == UserRole.ADMIN) {
                noPermissions = false;
            }
        }
    } catch (e) {
        noPermissions = true;
    }
    return noPermissions;
}

export function isObjectEmpty(obj) {
    return !obj || Object.keys(obj).length === 0;
}

export function userExists(user: IManageUser): boolean {
    return !isObjectEmpty(user);
}

export function isReseller(user: IManageUser): boolean {
    return userExists(user) && user?.org_type.value === OrgType.RESELLER;
}

export function isMSP(user: IManageUser): boolean {
    return userExists(user) && user?.org_type.value === OrgType.MSP;
}

export function isCustomer(user: IManageUser): boolean {
    return userExists(user) && user?.org_type.value === OrgType.CUSTOMER
}

export function isResellerOrMSP(user: IManageUser): boolean {
    return isReseller(user) || isMSP(user);
}
